import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=4c955e98&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=4c955e98&lang=scss"
import style1 from "./Header.vue?vue&type=style&index=1&id=4c955e98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c955e98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c955e98')) {
      api.createRecord('4c955e98', component.options)
    } else {
      api.reload('4c955e98', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=4c955e98&scoped=true", function () {
      api.rerender('4c955e98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/header/Header.vue"
export default component.exports